import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export default function Analytics() {
  const location = useLocation();
  const [measurementId, setMeasurementId] = useState<string | null>(null);

  useEffect(() => {
    // @ts-ignore
    const id = import.meta.env.VITE_GA_MEASUREMENT_ID;
    if (id) {
      setMeasurementId(id);
    }
  }, []);

  useEffect(() => {
    if (!measurementId) return;

    if (!document.getElementById('ga-script')) {
      const script = document.createElement('script');
      script.id = 'ga-script';
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
      document.head.appendChild(script);

      window.dataLayer = window.dataLayer || [];
      window.gtag = function() {
        // eslint-disable-next-line prefer-rest-params
        window.dataLayer.push(arguments);
      };
      window.gtag('js', new Date());
      window.gtag('config', measurementId, { send_page_view: false });
    }

    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search
      });
    }
  }, [measurementId, location.pathname, location.search]);

  return null;
}
